export const URL=`https://reembolsohomologapi.rehagro.com.br/api`;
